import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ACTION_TYPES, useBudgetProgramCreateEditDispatch, useBudgetProgramCreateEditState } from './budget-program-create-edit-context';
import BudgetProgramAppService from '../../../../application/platform/sge/budget-program/budget-program-app-service';
import BudgetUnitAppService from '../../../../application/platform/sge/budget-unit/budget-unit-app-service';
import { useBaseLayout } from '../../../../components/context/use-base-layout';

export const useBudgetProgramCreateEditController = () => {
    const navigate = useNavigate();
    const dispatch = useBudgetProgramCreateEditDispatch();
    const state = useBudgetProgramCreateEditState();
    const { showMessage, showLoading } = useBaseLayout();
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        async function loadInitialData() {
            showLoading({ open: true });
            try {
                const budgetUnits = await BudgetUnitAppService.list();
                dispatch({ type: ACTION_TYPES.setBudgetUnits, payload: budgetUnits });

                if (state.budgetProgramId) {
                    const data = await BudgetProgramAppService.getById(Number(state.budgetProgramId));
                    dispatch({ type: ACTION_TYPES.setBudgetProgramRequest, payload: { budgetUnitId: data.budgetUnitId, code: data.code, name: data.name } });
                }
            } catch (error: any) {
                showMessage({ open: true, message: 'Não foi possível carregar os dados do programa orçamentário', detail: error?.details || error?.message, type: 'error' });
            } finally {
                showLoading({ open: false });
            }
        }
        loadInitialData();
    }, [state.budgetProgramId]);

    function handleOnChange(e: any) {
        const { name, value } = e.target;
        const parsed = name === 'budgetUnitId' ? (value ? parseInt(value, 10) : undefined) : value;
        dispatch({ type: ACTION_TYPES.updateBudgetProgramRequest, payload: { [name]: parsed } });
    }

    async function handleSave() {
        if (!state.budgetProgramRequest.budgetUnitId || !state.budgetProgramRequest.code || !state.budgetProgramRequest.name) {
            dispatch({ type: ACTION_TYPES.setShowValidationErrors, payload: true });
            return;
        }
        setIsSaving(true);
        try {
            if (state.budgetProgramId) {
                await BudgetProgramAppService.edit(Number(state.budgetProgramId), state.budgetProgramRequest);
                showMessage({ open: true, message: 'Programa orçamentário atualizado com sucesso!', type: 'success' });
            } else {
                await BudgetProgramAppService.add(state.budgetProgramRequest);
                showMessage({ open: true, message: 'Programa orçamentário adicionado com sucesso!', type: 'success' });
            }
            setTimeout(() => navigate('/programas-orcamentarios'), 1500);
        } catch (error: any) {
            showMessage({ open: true, message: 'Não foi possível salvar o programa orçamentário', detail: error?.details || error?.message, type: 'error' });
        } finally {
            setIsSaving(false);
        }
    }

    function handleCancel() {
        navigate('/programas-orcamentarios');
    }

    return { handleOnChange, handleSave, handleCancel, isSaving };
};
